import router from './router'
import store from './store'
import { ElMessage } from 'element-plus'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import getPageTitle from '@/utils/get-page-title'
import roles from '@/router/roles'
import { hasAccess, nextPage } from '@/router/permission'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = [
  '/login-c',
  '/login-b',
  '/auth-redirect',
  '/azure-redirect',
  '/403',
  '/404',
  '/account-transfer',
  '/pass-reset',
  '/pass-update',
  '/environment',
  '/lasso/callback',
  '/lasso/test',
  '/temporarily',
  '/temporarily/detail',
  '/page-pdf'
] // no redirect whitelist

if (process.env.VUE_APP_ENV !== 'production') {
  whiteList.push('/login-bb')
}

router.beforeEach(async(to, from) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = store.getters['user/token']

  if (hasToken) {
    if (to.path === '/login-c' || to.path === '/login-b') {
      // if is logged in, redirect to the home page
      NProgress.done()
      return { path: '/' }
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const isRouterInited = store.getters['permission/addRoutes'] && store.getters['permission/addRoutes'].length > 0
      if (isRouterInited) {
        if (to.meta && to.meta.permissionTag && !hasAccess(to.meta.permissionTag)) {
          return { path: nextPage(to.meta.permissionTag) }
        }
        // continue navigation
        return true
      } else {
        try {
          // note: role must be a String! such as: 'Admin' or 'Customer' or 'Operator'
          const role = store.getters['user/role']

          if (role !== roles.roleCustomer) {
            await store.dispatch('user/getUserPermission')
          }

          // generate accessible routes map based on roles
          const accessRoutes = await store.dispatch('permission/generateRoutes', role)

          // dynamically add accessible routes
          // router.addRoutes(accessRoutes)
          accessRoutes.forEach(item => {
            router.addRoute(item)
          })

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          return { ...to, replace: true }
        } catch (error) {
          // remove token and go to login page to re-login
          store.commit('user/SET_TOKEN', '')
          ElMessage.error(error || 'Has Error')
          NProgress.done()
          return `/login-c?redirect=${to.path}`// ?redirect=${to.path}
        }
      }
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1 && !(to.path === '/pass-reset' && !store.getters['user/token_temp'])) {
      // in the free login whitelist, go directly
      // continue navigation
      return true
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      let loginUrl = '/login-c'
      const role = store.getters['user/role']
      if (!role) {
        NProgress.done()
        return `${loginUrl}`
      }
      loginUrl = role === roles.roleCustomer ? '/login-c' : '/login-b'
      // next(`${loginUrl}?redirect=${to.path}`)// ?redirect=${to.path}
      NProgress.done()
      return { path: loginUrl, query: { redirect: to.path, ...to.query }}
    }
  }
})
router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
